import React from "react"
import ThemeProvider from "@material-ui/styles/ThemeProvider"

import Layout from "../../../components/layout"
import SEO from "../../../components/seo"
import StudyRoutinePost from "../../../components/study-routine-post"
import theme from "../../../theme"

const summary = [
  {
    stage: "Primary",
    rhythm: "15 to 25 minutes, 2 to 3 days a week",
    focus: "Stories, timelines, people, places, simple cause and effect",
    habit: "Retell the event in order using who, when, where, and why",
  },
  {
    stage: "Lower secondary",
    rhythm: "25 to 40 minutes, 3 days a week",
    focus: "Chronology, sources, causes, consequences, paragraph answers",
    habit: "Build timelines and add evidence to each major event",
  },
  {
    stage: "Upper secondary",
    rhythm: "45 to 60 minutes, 4 days a week",
    focus: "Arguments, source analysis, historiography, essay structure",
    habit: "Plan essays with contention, evidence, and significance before writing",
  },
  {
    stage: "Exam block",
    rhythm: "Timed plans and responses",
    focus: "Evidence recall, source skills, essay timing, weak topics",
    habit: "Practise answering the exact question, not the topic you hoped for",
  },
]

const sections = [
  {
    title: "Primary: tell the story clearly",
    paragraphs: [
      "Primary history study should focus on stories, timelines, people, places, and simple cause and effect. Students need to know what happened before they analyse why it mattered.",
      "A short retelling using who, when, where, what, and why is a strong study task.",
    ],
  },
  {
    title: "Lower secondary: connect events and evidence",
    paragraphs: [
      "Lower secondary students should build timelines, define key terms, summarise causes and consequences, and practise using evidence in paragraphs.",
      "Source work should include origin, purpose, content, and usefulness. These habits become easier when practised in small pieces.",
    ],
  },
  {
    title: "Upper secondary: argue with evidence",
    paragraphs: [
      "Upper secondary history needs planning before writing. Students should form a contention, choose evidence, consider significance, and organise paragraphs around argument rather than chronology alone.",
      "Timed essay plans are useful because they train decision-making without requiring a full essay every session.",
    ],
  },
  {
    title: "A simple weekly rhythm",
    paragraphs: [
      "Use a calendar for timeline review, key terms, source analysis, evidence recall, essay plans, timed paragraphs, and feedback review.",
      "A good history routine turns content into argument: what happened, why it happened, what changed, and why it matters.",
    ],
  },
]

const HistoryStudyRoutines = () => (
  <ThemeProvider theme={theme}>
    <Layout>
      <SEO
        title="History Study Plan by School Level"
        description="Plan history study routines for primary, lower secondary, upper secondary, and exam periods with timelines, source analysis, evidence, and essay planning."
      />
      <StudyRoutinePost
        subject="History"
        title="History study routines for different school levels"
        intro="A strong history routine helps students move from remembering events to explaining causes, evidence, change, and significance."
        sharedCalendarUrl="https://app.schoolcalendar.me/calendar/afraid-rat-77"
        image="blog-history.png"
        imageAlt="History study planning"
        summary={summary}
        sections={sections}
      />
    </Layout>
  </ThemeProvider>
)

export default HistoryStudyRoutines
